import { render, staticRenderFns } from "./SeabornBackground.vue?vue&type=template&id=d172fc1c&scoped=true&"
import script from "./SeabornBackground.vue?vue&type=script&lang=js&"
export * from "./SeabornBackground.vue?vue&type=script&lang=js&"
import style0 from "./SeabornBackground.vue?vue&type=style&index=0&id=d172fc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d172fc1c",
  null
  
)

export default component.exports